import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { Row, Col, Container } from 'reactstrap';
import InfiniteScroll from 'react-infinite-scroller';
import areIntlLocalesSupported from 'intl-locales-supported';

import * as generalActions from 'modules/general/action';
import * as penalizacionesAction from '../action';
import PenalizacionRow from './penalizacionRow';

let DateTimeFormat;
if (areIntlLocalesSupported(['es', 'es-AR'])) {
  DateTimeFormat = global.Intl.DateTimeFormat;
} else {
  const IntlPolyfill = require('intl');
  DateTimeFormat = IntlPolyfill.DateTimeFormat;
  require('intl/locale-data/jsonp/es');
  require('intl/locale-data/jsonp/es-AR');
}

const fechaFormat = {
  month: 'long',
  year: 'numeric',
};

@connect((store) => ({
  penalizaciones: store.getIn(['penalizaciones', 'lista']),
  scrollControl: store.getIn(['penalizaciones', 'scrollControl']),
  loading: store.getIn(['general', 'loadingbar', 'show']),
}))
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = { solucionado: false, pago: false, documentoUsuario: false, fechaSeleccionada: new Date() };
  }
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('PENALIZACIONES'));
    this.props.penalizaciones.size === 0 && this.filtrar();
  };
  filtrar = (reset) => {
    const { scrollControl } = this.props;
    const { solucionado, pago, documentoUsuario, fechaSeleccionada } = this.state;
    if (reset) this.props.dispatch(penalizacionesAction.clear('all'));
    this.props.dispatch(penalizacionesAction.get(solucionado, pago, documentoUsuario, moment(fechaSeleccionada).toISOString(), reset ? 0 : scrollControl.get('cantResults')));
  };
  componentDidUpdate = (prevProps, prevState) => {
    const { dispatch } = this.props;
    const { fechaSeleccionada } = this.state;
    if (fechaSeleccionada && !moment(fechaSeleccionada).isSame(moment(prevState.fechaSeleccionada))) {
      dispatch(penalizacionesAction.clear('all'));
    }
  };
  componentWillUnmount = () => {
    this.props.dispatch(penalizacionesAction.clear('lista'));
  };
  disableDates = (date) => moment(date).isAfter(moment());
  render() {
    const { penalizaciones, loading, dispatch, scrollControl } = this.props;
    const { solucionado, pago, documentoUsuario, fechaSeleccionada } = this.state;

    return (
      <Container fluid>
        <Row className="mb-20">
          <Col md="12">
            <MaterialUI.Paper zDepth={2}>
              <Row className="p-lr-10">
                <Col md="2" sm="4">
                  <MaterialUI.DatePicker
                    autoOk
                    onDismiss={() => false}
                    DateTimeFormat={DateTimeFormat}
                    underlineStyle={{ display: 'none' }}
                    cancelLabel="Cancelar"
                    formatDate={new DateTimeFormat('es-AR', Object.assign({ day: 'numeric' }, fechaFormat)).format}
                    locale="es-AR"
                    onChange={(dummy, fechaSeleccionada) => this.setState({ fechaSeleccionada })}
                    value={fechaSeleccionada}
                    floatingLabelText="Fecha Seleccionada"
                    hintText="Fecha"
                    container="inline"
                    mode="landscape"
                    shouldDisableDate={this.disableDates}
                  />
                </Col>
                <Col md="2" className="pt-30">
                  <MaterialUI.Checkbox label="Solucionadas" checked={solucionado} onCheck={(e, solucionado) => this.setState({ solucionado })} />
                  <MaterialUI.Checkbox label="Pagas" checked={pago} onCheck={(e, pago) => this.setState({ pago })} />
                </Col>
                <Col md={{ size: 4 }}>
                  <Row>
                    <Col md={2}>
                      <FontAwesome name="search" className="pt-30" size="2x" />
                    </Col>
                    <Col md={8}>
                      <MaterialUI.TextField
                        hintText="DNI del pasajero"
                        floatingLabelText="Buscar por DNI del pasajero"
                        fullWidth={true}
                        value={documentoUsuario || null}
                        onChange={(e, documentoUsuario) => this.setState({ documentoUsuario })}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md="2" sm="3" xs="2" className="pt-25">
                  <MaterialUI.RaisedButton fullWidth label="Filtrar" disabled={loading || !scrollControl.get('hasMore')} onTouchTap={() => this.filtrar(true)} />
                </Col>
              </Row>
            </MaterialUI.Paper>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <MaterialUI.Paper zDepth={2}>
              <MaterialUI.List className="noPadding">
                <InfiniteScroll threshold={1} initialLoad={false} loadMore={scrollControl.get('hasMore') ? () => this.filtrar() : () => false} hasMore={!loading && scrollControl.get('hasMore')}>
                  {penalizaciones && penalizaciones.map((penalizacion) => <PenalizacionRow key={penalizacion.get('id')} penalizacion={penalizacion} dispatch={dispatch} />)}
                </InfiniteScroll>
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/penalizaciones/components/lista.js